import React from 'react';
import { Loading } from '@cotera/client/app/components';

export const ChatBotMappingSectionLoading: React.FC<{
  title: string;
  description: string;
}> = ({ title, description }) => {
  return (
    <div className="space-y-3">
      <div>
        <p className="text-sm font-medium">{title}</p>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      <div className="space-y-2">
        <Loading.Shimmer className="h-16 w-full rounded-md" />
        <Loading.Shimmer className="h-16 w-full rounded-md" />
      </div>
    </div>
  );
};
